export default "__VITE_ASSET__DJfbcmYt__"